export default {
  en: {
    all: 'All',
    refCode: 'Ref. Code',
    code: 'Code',
    agent: 'Agent',
    hotel: 'Hotel',
    promotion: 'Promotion',
    specialOfferValid: 'Special Offer Valid',
    selectDate: 'Select date',
    moreFilter: 'More Filter',
    status: 'Status',
    market: 'Market',
    salePerson: 'Sale Person',
    validBookingDate: 'Valid Booking Date',
    periodOfIssueDate: 'Period of Issue Date',
    startDate: 'Start Date',
    endDate: 'End Date',
    search: 'Search',
    reset: 'Reset',
    draft: 'Draft',
    published: 'Published'
  },
  th: {
    all: 'ทั้งหมด',
    refCode: 'รหัสอ้างอิง',
    code: 'รหัส',
    agent: 'ตัวแทน',
    hotel: 'โรงแรม',
    promotion: 'โปรโมชั่น',
    specialOfferValid: 'วันที่เสนอข้อเสนอพิเศษ',
    selectDate: 'กรุณาเลือกวันที่',
    moreFilter: 'เพิ่มเติม',
    status: 'สถานะ',
    market: 'ตลาด',
    salePerson: 'พนักงานขาย',
    validBookingDate: 'วันที่จอง',
    periodOfIssueDate: 'ช่วงเวลาที่ออกข้อเสนอพิเศษ',
    startDate: 'ตั้งแต่',
    endDate: 'สิ้นสุด',
    search: 'ค้นหา',
    reset: 'ล้างค่า',
    draft: 'ฉบับร่าง',
    published: 'เผยแพร่'
  }
}
